import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const ViewClient = ({ viewObj }) => {
  const [viewObjData, setViewObjData] = useState([]);

  useEffect(() => {
    if (viewObj) {
      setViewObjData(viewObj);
    }
  }, [viewObj]);

  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewReg"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "45%", maxWidth: "45%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">View Client</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="content">
              <div className="row">
                <div className="col-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Name}
                    onChange={(e) =>
                      setViewObjData({ ...viewObjData, Name: e.target.value })
                    }
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Company</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Company}
                    onChange={(e) =>
                      setViewObjData({
                        ...viewObjData,
                        Company: e.target.value,
                      })
                    }
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Email}
                    onChange={(e) =>
                      setViewObjData({ ...viewObjData, Email: e.target.value })
                    }
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Contact No</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Phone}
                    onChange={(e) =>
                      setViewObjData({ ...viewObjData, Phone: e.target.value })
                    }
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Location</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Location}
                    onChange={(e) =>
                      setViewObjData({
                        ...viewObjData,
                        Location: e.target.value,
                      })
                    }
                    readOnly
                  />
                </div>
                <div className="col-6 mb-3">
                  <label className="form-label">Website</label>
                  <input
                    type="text"
                    className="form-control"
                    value={viewObjData?.Website}
                    onChange={(e) =>
                      setViewObjData({
                        ...viewObjData,
                        Website: e.target.value,
                      })
                    }
                    readOnly
                  />
                </div>
              </div>
              <div>
                <button
                  type="button"
                  className="btn btn-secondary d-flex ms-auto mt-3"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

ViewClient.propTypes = {
  viewObj: PropTypes.object.isRequired,
};

export default ViewClient;
